import { createAction, props } from '@ngrx/store';
import { EducationalContentEntity } from '../../models/educational-content.entities';

//-- AEM Educational Content
export const loadAEMContent = createAction(
  '[SkyMiles Educational Page/AEM] Load AEM Content'
);

export const loadAEMContentSuccess = createAction(
  '[SkyMiles Educational Page/AEM] Load Content Success',
  props<{ aemContent: EducationalContentEntity }>()
);

export const loadAEMContentFailure = createAction(
  '[SkyMiles Educational Page/AEM] Load AEM Content Failure',
  props<{ aemContentError: EducationalContentEntity }>()
);
